module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/edit-inactive-62edd5d3e9e0e637f6dab02716f1b6bb.svg";